module.exports = __webpack_public_path__ + "img/status4.400e7ce3.png";